import { generateActions } from "../generateActions";
import { eChuongTrinhDaoTaoSoSanhActionsObj } from "../../action-types/ctdt/IChuongTrinhDaoTaoSoSanhActionTypes";

export const chuongTrinhDaoTaoSoSanhActions = {
    ...generateActions(eChuongTrinhDaoTaoSoSanhActionsObj, "CHUONG_TRINH_DAO_TAO_SO_SANH"),
};
